import { Component, OnInit } from '@angular/core';
import {
  GameRoundInfo
} from "src/data/game-round";
import {
  CompetitionInfo
} from "src/data/competition-data";
import {
  PlayerService
} from "src/providers/player-service/player-service";
import {
  Country
} from "src/data/country-location";
import {
  TeeBox
} from "src/data/tee-box";
import {
  TeeBoxInfo
} from "src/data/club-course";
import * as moment from 'moment';
import { LoadingController, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-select-dates',
  templateUrl: './select-dates.page.html',
  styleUrls: ['./select-dates.page.scss'],
})
export class SelectDatesPage implements OnInit {

  ngOnInit() {
  }

  public competition: CompetitionInfo;
  public gameRound: GameRoundInfo;
  public headerName: string;
  public countryList: Array < Country > ;
  public teeBox: Array < TeeBox > ;
  public teeBoxes: Array < TeeBoxInfo > ;

  startDate: any = moment(); //moment().format("YYYY-MMM-DD");
  endDate: any = moment(); //moment().format("YYYY-MMM-DD");
  fromTime: any = moment();
  toTime: any = moment();

  today: any = moment().format("YYYY-MM-DD");

  type: string = '';
  range: boolean = false;

  minuteRange = [0,5,10,15,20,25,30,35,40,45,50,55];

  dataExtras:any;
  constructor(public nav: NavController,
      private navParams: NavParams,
      private modalCtrl: ModalController,
      private playerService: PlayerService,
      private loadingCtl: LoadingController,
      private toastCtl: ToastController,
      private platform: Platform, private router: Router,) {
        // this.dataExtras = this.router.getCurrentNavigation().extras.state;
        
      this.competition = this.navParams.get("competition");
      this.gameRound = this.navParams.get("gameRound");
      this.headerName = this.navParams.get("headerName");
      this.teeBoxes = navParams.get("teeBoxes");
      // this.startDate = moment(this.prs.startTime,"HH:mm:ss").format("YYYY-MM-DDTHH:mmZ");
      // this.startDate = this.startDate.
      this.startDate = moment(this.startDate).format("YYYY-MMM-DD");
      this.endDate = moment(this.endDate).format("YYYY-MMM-DD");
   
      this.type = navParams.get('type');
      if(this.type === 'times') {
          this.fromTime = navParams.get("fromTime");
          this.toTime = navParams.get("toTime");
      } else if (this.type === 'dates') {
          this.startDate = navParams.get("startDate");
          this.endDate = navParams.get("endDate");
      }
      this.range = navParams.get("range");


      
  }

  _range(start, stop, step) {
      var a = [start], b = start;
      while (b < stop) {
          a.push(b += step || 1);
      }
      return a;
  }

  close() {
      this.modalCtrl.dismiss();
  }

  ionViewDidLoad() {
   
      // this.getTeeBox();
  }

  getInnerHTML() {
      let description = "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>"
      return description;
  }

  countrySelected(country ? : any) {
      if (country == null)
          this.modalCtrl.dismiss();
      else this.modalCtrl.dismiss(country);
  }


  async getCountry(cb ? ) {
      let loader = await this.loadingCtl.create({
        message: "Getting Country List...",
        showBackdrop: false
      });
      loader.present().then(() => {
          this.playerService.getCountryList()
              .subscribe((data: Array < Country > ) => {
                  loader.dismiss().then(() => {
                      
                      this.countryList = data;
                      
                  })
              });
      })



      // setTimeout(()=>{
      
      //     cb();

      // }, 0)
  }

  getFlagUrl(flagUrl: string) {
      if (flagUrl == null) return null;
      else {
          let flagIcon = flagUrl.split("/");
          return "img/flag/" + flagIcon[2];
      }
  }

  async getTeeBox() {
      let loader = await this.loadingCtl.create({
          message: "Getting Teebox List...",
          showBackdrop: false
      });
      loader.present().then(() => {
          this.playerService.getTeeBox()
              .subscribe((data: Array < TeeBox > ) => {
                  loader.dismiss().then(() => {
                      
                      this.teeBox = data;
                      
                  })
              }, (error) => {
                  if (error) {
                      loader.dismiss().then(() => {
                          loader = null;
                      });
                  }

              }, () => {
                  // loader.dismiss().then(() => {
                  //     loader = null;
                  // });
              });
      })
  }

  onSelectTeebox(t: TeeBox) {
      this.modalCtrl.dismiss(t);
  }

  getTeeColor(color: string) {
      if (color === 'Blue') {
          return 'secondary'
      } else if (color === 'Red') {
          return 'danger'
      } else if (color === 'Black') {
          return 'dark'
      } else if (color === 'White') {
          return 'light'
      } else if (color === 'Gold') {
          return 'gold'
      }
  }

  onApplyClick() {
      if(this.type === 'times') {
          if(this.fromTime > this.toTime ) {
              MessageDisplayUtil.showMessageToast('Please select valid Time Range', 
                  this.platform, this.toastCtl, 3000, "bottom");
                  return false;
          }
      }
   
    //   this.modalCtrl.dismiss({
    //       fromTime: this.fromTime,
    //       toTime: this.toTime,
    //       startDate: this.startDate,
    //       endDate: this.endDate
    //   });

      this.modalCtrl.dismiss({ range: this.range,fromTime: this.fromTime,
        toTime: this.toTime,
        startDate: this.startDate,
        endDate: this.endDate }, null, "SelectDatesPage");
  }

  validTime() {

  }

}
